<template>
    <PopupRouterViewDetail label="Customer Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Customer" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-code" label-cols-lg="12"  label="Customer Code" label-for="input-code" size="sm" :model.sync="model.code" :isRequired="true" :state="validateState('code')" :errorMessage="getErrorMessage(errorMessage.code, 'code')"  @change="updateData"  :isUpdatable="true" />
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Customer Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"  @change="updateData"  :isUpdatable="true" />
						<app-input-textarea id="fieldset-office-address" label-cols-lg="12"  label="Office Address" label-for="input-office-address" size="sm" :model.sync="model.officeAddress"  @change="updateData"  :isUpdatable="true" />
						<app-input-textbox id="fieldset-office-phone-number" label-cols-lg="12"  label="Office Phone Number" label-for="input-office-phone-number" size="sm" :model.sync="model.officePhoneNumber"  @change="updateData"  :isUpdatable="true" :thousandSeparator="false"  />
						<app-input-textbox id="fieldset-stock-level" label-cols-lg="12"  label="Stock Level Customer (Day) " label-for="input-stock-level" size="sm" type="number" :model.sync="model.stockLevel" :isRequired="true" :state="validateState('stockLevel')" :errorMessage="getErrorMessage(errorMessage.stockLevel, 'stockLevel')"  @change="updateData"  :isUpdatable="true" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-code-surat-jalan" label-cols-lg="12"  label="Code Surat Jalan" label-for="input-code-surat-jalan" size="sm" :model.sync="model.codeSuratJalan"  @change="updateData"  :isUpdatable="true" />
						<app-input-textbox id="fieldset-contact-person" label-cols-lg="12"  label="Contact Person" label-for="input-contact-person" size="sm" :model.sync="model.contactPerson"  @change="updateData"  :isUpdatable="true" />
						<app-input-textbox id="fieldset-contact-person-phone-number" label-cols-lg="12"  label="Contact Person Phone Number" label-for="input-contact-person-phone-number" size="sm" :model.sync="model.contactPersonPhoneNumber"  @change="updateData"  :isUpdatable="true" :thousandSeparator="false"  />
						<app-input-textbox id="fieldset-contact-person-email" label-cols-lg="12"  label="Contact Person Email" label-for="input-contact-person-email" size="sm" :model.sync="model.contactPersonEmail"  @change="updateData"  :isUpdatable="true" />
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import Customer from '@/models/Customer/Customer';
import CustomerList from '@/models/Customer/CustomerList';
import CustomerFilter from '@/filters/Customer/CustomerFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputTextbox from '@/components/AppInputTextboxNumberCustom';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		AppInputTextarea,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			code: {required},
			name: {required},
			stockLevel: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				code: { required : "Customer Code is Required."},
				name: { required : "Customer Name is Required."},
				stockLevel: { required : "Stock Level Customer (Day)  is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterCustomer : null,
			currentCustomerPage : 1,
			customerPageSize: 10,
			sortByCustomer: '',
			sortDescCustomer: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getCustomer : async function(id) {
			this.isBusy = true;
			Customer.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadCustomer = true;
			this.filterCustomer.id = this.modelId;
			Customer.downloadDataDetail(this, this.filterCustomer).then(result => {
				this.isDownloadCustomer = false;
			}).catch(error => { this.isDownloadCustomer = false; })
		},
		getCustomers : async function(input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.Code = input;
			}
			this.isCustomerComboLoading = true;
			Customer.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.customers = result.data
				}
				this.isCustomerComboLoading = false;
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.customerInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						Customer.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'customerindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						Customer.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'customerindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					Customer.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getCustomer(id);
					});
				}
			});
		},
		onHidden() {
			this.getCustomers();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterCustomer = new CustomerFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getCustomer(id);
			} else {
				this.modelId = id;
				this.getCustomer(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
